import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import COLLEGE_MAP from "../../constants/colleges";

const LatestStories = () => {
  const [articles, setArticles] = useState([]);
  const [featuredIndex, setFeaturedIndex] = useState(0);
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  useEffect(() => {
    // Replace with your actual API endpoint
    axios
      .get("https://ethiccraft.org/backend/latest_stories/read_isShown.php")
      .then((res) => {
        setArticles(res.data);
      })
      .catch((err) => {
        console.error("Error fetching articles:", err);
      });
  }, []);

  useEffect(() => {
    if (articles.length > 1) {
      const interval = setInterval(() => {
        setFeaturedIndex((prevIndex) => (prevIndex + 1) % articles.length);
      }, 25000);

      return () => clearInterval(interval);
    }
  }, [articles]);

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  if (articles.length === 0 || !articles[featuredIndex]) {
    // You can add a more sophisticated loading skeleton here
    return <div>Loading Stories...</div>;
  }

  return (
    <motion.section
      className="latest-stories"
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
    >
      <div className="stories-header">
        <motion.h2 variants={itemVariants}>Latest Stories</motion.h2>
      </div>

      <motion.div className="main-content" variants={containerVariants}>
        <motion.div className="featured-article" variants={itemVariants}>
          <motion.div
            className="featured-image-wrapper"
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.4 }}
          >
            <img
              src={`https://ethiccraft.org/${articles[featuredIndex].image}`}
              alt="Featured"
            />
          </motion.div>
          <div className="featured-text">
            <motion.span className="category" variants={itemVariants}>
              {(
                COLLEGE_MAP[articles[featuredIndex].college.toLowerCase()] ||
                articles[featuredIndex].college ||
                "N/A"
              ).length > 40
                ? (
                    COLLEGE_MAP[
                      articles[featuredIndex].college.toLowerCase()
                    ] ||
                    articles[featuredIndex].college ||
                    "N/A"
                  ).substring(0, 40) + "..."
                : COLLEGE_MAP[articles[featuredIndex].college.toLowerCase()] ||
                  articles[featuredIndex].college.toLowerCase() ||
                  "N/A"}
            </motion.span>
            <motion.h3 variants={itemVariants}>
              {articles[featuredIndex].title}
            </motion.h3>
            <motion.p className="meta" variants={itemVariants}>
              {articles[featuredIndex].date}
            </motion.p>
            <motion.p className="description" variants={itemVariants}>
              {articles[featuredIndex].description}
            </motion.p>
          </div>
        </motion.div>

        <motion.div className="side-articles" variants={containerVariants}>
          {articles.map((item, idx) => (
            <motion.div
              className="side-article"
              key={idx}
              variants={itemVariants}
              whileHover={{ scale: 1.05, x: 5, backgroundColor: "#ffffff" }}
              transition={{ duration: 0.3 }}
              onClick={() => setFeaturedIndex(idx)}
            >
              <img
                src={`https://ethiccraft.org/${item.image}`}
                alt={item.title}
              />
              <div className="text">
                <span className="category">
                  {(
                    COLLEGE_MAP[item.college.toLowerCase()] ||
                    item.college ||
                    "N/A"
                  ).length > 40
                    ? (
                        COLLEGE_MAP[item.college.toLowerCase()] ||
                        item.college ||
                        "N/A"
                      ).substring(0, 40) + "..."
                    : COLLEGE_MAP[item.college.toLowerCase()] ||
                      item.college.toLowerCase() ||
                      "N/A"}
                </span>
                <h4>{item.title}</h4>
                <p className="meta">{item.date}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default LatestStories;
